export const AdultsKey = "adults";
export const MaleKey = "male";
export const FemaleKey = "female";
export const ChildrenKey = "children";
export const ChildrenAKey = "childrenA";
export const ChildrenA2Key = "childrenA2";
export const ChildrenBKey = "childrenB";
export const ChildrenB2Key = "childrenB2";
export const ChildrenCKey = "childrenC";
export const ChildrenDKey = "childrenD";
export const ChildrenOther1Key = "childrenOther1";
export const ChildrenOther2Key = "childrenOther2";
export const ChildrenOther3Key = "childrenOther3";
export const InfantsKey = "infants";
export const RoomKey = "room";
export const PlanKey = "plan";
export const BasicChargeKey = "basicCharge";
export const RoomBasicChargeKey = "roomBasicCharge";

export const AgeTypes = [
  AdultsKey,
  ChildrenKey,
  ChildrenAKey,
  ChildrenA2Key,
  ChildrenBKey,
  ChildrenB2Key,
  ChildrenCKey,
  ChildrenDKey,
  ChildrenOther1Key,
  ChildrenOther2Key,
  ChildrenOther3Key,
  InfantsKey,
  RoomKey,
];
